import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Col, Container, Row } from "reactstrap"

import CropPlanner from "./crop-planner"

import { getAreas, updateArea } from "../../store/goals/actions"
import { getProfile } from "../../store/auth/profile/actions"

const PlantsCropPlanner = (props) => {
    const { userareas, onGetAreas, onGetProfile, onUpdateArea } = props

    const [currYear] = useState(new Date().getFullYear())

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("user"))
        if (user) onGetProfile(user.user)
        onGetAreas()
    }, [])

    function handleAddRotationToArea(areaId, plantsToAdd) {
        const area = userareas.find(a => a.id === areaId)
        if (!area) return
        onUpdateArea({ ...area, plants: [...area.plants, ...plantsToAdd] })
    }

    return (
        <div className="page-content">
            <Container fluid>
                <CropPlanner
                    areas={userareas}
                    currYear={currYear}
                    onAddRotationToArea={handleAddRotationToArea}
                />
            </Container>
        </div>
    )
}

const mapStateToProps = (state) => ({
    userareas: (state.goals.areas || [])
        .map(area => {
            const copy = structuredClone(area)
            copy.plants = copy.plants.filter(p => p.species !== undefined)
            return copy
        })
        .sort((a, b) => a.name.localeCompare(b.name)),
})

const mapDispatchToProps = (dispatch) => ({
    onGetProfile: (username) => dispatch(getProfile(username)),
    onGetAreas: () => dispatch(getAreas()),
    onUpdateArea: (area) => dispatch(updateArea(area)),
})

export default connect(mapStateToProps, mapDispatchToProps)(PlantsCropPlanner)
